





















import Vue, { VueConstructor } from 'vue'
import Logo from '@/components/atoms/Logo/Logo.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XStepper from '@/components/atoms/Stepper/XStepper.vue'
import StepOne from './Steps/StepOne.vue'
import StepTwo from './Steps/StepTwo.vue'
import StepThree from './Steps/StepThree.vue'
import CREATE_PARTNER_APPLICATION_MUTATION from '@/graphql/partner/createPartnerApplication.gql'
import {
  CreatePartnerApplicationInput,
  Mutation,
} from '@/types/generated/graphql'
import { showToast } from '@/packages/toast'
import StepFour from './Steps/StepFour.vue'

const steps = ['step1', 'step2', 'step3', 'step4'] as const
export type Step = typeof steps[number]

export type Data = {
  currentStep: Step
  input: CreatePartnerApplicationInput & { storeCount?: number }
}

type Methods = {
  onSubmit: () => void
  onNext: (step: Step) => void
  reset: () => void
}

const pages: { [key in Step]: VueConstructor<Vue> } = {
  step1: StepOne,
  step2: StepTwo,
  step3: StepThree,
  step4: StepFour,
}

// TODO ブラウザバック時にアラートを出す
export default Vue.extend<Data, {}, Methods, {}>({
  name: 'PartnerSignup',
  components: {
    Logo,
    XButton,
    XCard,
    XStepper,
    ...pages,
  },
  data() {
    return {
      currentStep: 'step1',
      input: {
        applicantFirstName: '',
        applicantLastName: '',
        applicantEmail: '',
        useAffiliate: false,
        servicePlanIds: [],
        companyName: '',
        ownerName: '',
        zipCode: '',
        prefId: 0,
        address1: '',
        address2: '',
        phone: '',
        siteUrl: '',
        referrer: '',
        storeApplications: [],
        storeCount: undefined,
      },
    }
  },
  methods: {
    async onSubmit() {
      const { storeCount, ...input } = this.input
      await this.$apollo.mutate<Mutation>({
        mutation: CREATE_PARTNER_APPLICATION_MUTATION,
        variables: { input },
      })

      showToast(this.$tc('partnersignup.completedMessage'))
      this.reset()
      this.onNext('step4')
    },
    onNext(step: Step) {
      this.currentStep = step
    },
    reset() {
      const { data } = this.$options as any
      Object.assign(this.$data.input, data?.apply(this).input)
    },
  },
})
